import { action } from 'satcheljs';
export var createEmail = action('createEmail');
//# sourceMappingURL=createEmail.js.map